import { Component, Inject } from '@angular/core';
import { MODAL_WINDOW_TITLE } from "@modules/tests/dialogs/enums/modal-window-title.enum";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import { DialogsData } from "@modules/tests/tabs/tabs.component";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { SPORT_NAME_ENUM } from "@shared/enums/sport-name.enum";
import { AppConstants } from "@core/constants";

@Component({
  selector: 'app-manual-effort-dialog',
  templateUrl: './manual-effort-dialog.component.html',
  styleUrls: ['./manual-effort-dialog.component.scss']
})
export class ManualEffortDialogComponent {
  protected modalWindowTitle: MODAL_WINDOW_TITLE = MODAL_WINDOW_TITLE.POWER_DURATION;
  public form!: UntypedFormGroup;

  constructor(
    private dialogRef: MatDialogRef<ManualEffortDialogComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogsData,
    private snackBar: MatSnackBar,
  ) {}

  public initForm(): void {
    this.form = this.fb.group({
      duration_efforts: new UntypedFormControl(
        this.data.duration_efforts,
        Validators.required
      ),
      average_speed: new UntypedFormControl(
        this.data.average_speed,
        Validators.required
      ),
      average_power: new UntypedFormControl(
        this.data.average_power,
        Validators.required
      ),
    });
  }
  public ngOnInit(): void {
    this.initForm();

    if (this.data.test.sport.name === SPORT_NAME_ENUM.CYCLING || this.data.test.sport.name === SPORT_NAME_ENUM.TRIATHLON_CYCLING) {
      this.modalWindowTitle = MODAL_WINDOW_TITLE.POWER_ONLY_EFFORTS;
    }
  }

  public closeDialog(): void {
    this.dialogRef.close(false);
  }
  public save(): void {
    let manualEffortDialogData = {
      average_power: this.form.value.average_power,
      average_speed: this.form.value.average_speed / this.form.value.duration_efforts,
      initial_speed: this.form.value.average_speed,
      duration_efforts: this.form.value.duration_efforts,
      isSpeedBased: this.data.is_speed_sport,
      selected_power: this.data.selected_power,
      selected_speed: this.data.selected_speed,
    };
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    if (this.form.value.time > 25 && this.form.value.time < 135) {
      this.snackBar.open('Time must be in range of 12 to 25 seconds or 135 to 1800 seconds', 'OK', AppConstants.TOAST_CONFIG.ERROR);

      return;
    }
    this.dialogRef.close(manualEffortDialogData);
  }
}
